import React from 'react';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';

import Route from './ScrollToTopRoute';
import Loading from '../components/shared/Loading';

const AuthRoute = props => (
  <Query
    query={gql`
      {
        currentUser {
          id
          authenticationToken
          smsVerified
        }
      }
    `}
    pollInterval={1800000}>
    {({ loading, error, data, refetch }) => {
      if (loading) return <Loading size="3x" />;
      if (error) {
        return <Redirect to="/404" />;
      }
      return data && data.currentUser && data.currentUser.authenticationToken ? (
        <VerifiedRoute verified={data.currentUser.smsVerified} refetch={refetch} {...props} />
      ) : (
        <Redirect to="/logout" />
      );
    }}
  </Query>
);

const VerifiedRoute = ({ verified, path, refetch, ...props }) =>
  verified || ['/verify'].includes(path) ? (
    <Route refetchVerification={refetch} {...props} />
  ) : (
    <Redirect to="/verify" />
  );

export default AuthRoute;



// WEBPACK FOOTER //
// ./src/containers/AuthRoute.js